import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="row">
          <div className="col-md-12">
            <div id="textFooter">
              Step into a new universe of learning with Inflo
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
